import { PAGE_TYPES, STATUS_TEXT } from '../../shared/constants';

import { isBrowser } from '../generic';

interface Errors {
  type: string;
  code?: number | string;
  source?: string;
  message?: string;
}

export const formTrackPageView = (
  pageType: string,
  formID: string,
  name: string,
  stepName: string,
  stepID: string,
  version: string,
  formType: string,
  formContext?: string,
  eventName?: string,
  formStatus?: string,
  formOutcome?: string,
  errors?: Errors
) => {
  if (!isBrowser || !window.aabAnalytics) return;

  const formData: { [key: string]: string | undefined | number } = {
    page_url: window.location.href,
    page_language: 'nl',
    page_channel: 'open domain',
    form_id: `dpkn-${formID}`,
    form_name: name,
    form_type: formType || 'lead-soft',
    form_step_name: stepName,
    form_step_id: stepID,
    form_version: version,
    form_status: formStatus || '',
  };

  if (pageType) {
    formData.page_type = PAGE_TYPES[pageType] || pageType;
    formData.page_template = pageType.split('-').join(' ');
  }
  // Don't set this for initial call, since we don't have
  // the previous outcome to send out yet
  if (formContext) {
    formData.form_context = formContext;
  }

  if (formOutcome) {
    formData.form_outcome = formOutcome;
  }

  if (errors) {
    formData.error_type = errors.type;
    formData.error_code = errors?.code || STATUS_TEXT.UNKNOWN;
    formData.error_source = errors?.source || STATUS_TEXT.UNKNOWN;
    formData.error_message =
      errors?.message?.toLowerCase() || STATUS_TEXT.ERROR_FALLBACK;
  }

  window.aabAnalytics.push({
    command: 'ADD EVENT',
    name: eventName || 'pageview',
    data: formData,
  });
};

export const trackFormStepEvent = (
  pageType: string,
  id: string,
  formStatus: string,
  deqFormName: string,
  formOutcome?: string,
  formType?: string,
  errors?: Errors
) => {
  const formTypeTacking = formType || 'lead-hard';
  formTrackPageView(
    pageType,
    id,
    deqFormName,
    'end',
    '20',
    'v1',
    formTypeTacking,
    undefined,
    'form step',
    formStatus,
    formOutcome,
    errors
  );
};

export const FORM_TRACKING_STATUS = {
  endSuccess: 'end-success',
  endFail: 'end-fail',
};
